<button mat-icon-button [matDialogClose] class="modal-close-button" [disableRipple]="true">
    <i class="material-icons-round">clear</i>
</button>

<div class="h-100 w-100 background">
    <app-image-slider [images]="images" [descriptions]="descriptions" [autoSlide]="false" [equalDimension]="false" [fullScreenImage]="false" [startIndex]="imageIndex" [gallery]="false"></app-image-slider>
</div>